// extracted by mini-css-extract-plugin
module.exports = {"root":"Vv34s","blockingLayer":"_2Cu3B","dialog":"_3Ku-A","frameWrap":"lwWpR","iframe":"_3OVaT","xButton":"_144cS","bare":"Xwjfe"};